import moment from 'moment';
import 'moment-timezone';

export default class TimeZoneService {
	public static convertToLocal(date: string | Date | moment.Moment, timeZone: string): moment.Moment {
		return moment(moment.tz(date, timeZone).format('YYYY-MM-DD HH:mm:ss'));
	}

	public static convertFromLocal(date: string | Date | moment.Moment, timeZone: string): moment.Moment {
		return moment.tz(moment(date).format('YYYY-MM-DD HH:mm:ss'), timeZone);
	}
}
